'use client';

import { Toaster } from '@app/ui-system';
import { useToast } from '@app/ui-system/src/components/use-toast';
import Script from 'next/script';
import { ReactNode, useMemo } from 'react';
import { SkeletonTheme } from 'react-loading-skeleton';
import { Provider } from 'urql';

import { AppConfigProvider } from '@/modules/app-config-provider/AppConfigProvider';
// import { AppUserProvider } from '@/modules/app-user-provider/AppUserProvider';
import { DarkModeProvider } from '@/modules/dark-mode-provider/DarkModeProvider';
import { ENV } from '@/services/config/config';
import { urqlClient } from '@/services/urql/urql-client';

const IS_PROD = 1;
const PROD_GTM_ID = ENV.NODE_ENV === 'production' ? 'GTM-W6GHKTDW' : '';

export const ChatScript = () => {
  return (
    <Script id="chat" strategy="lazyOnload">
      {`var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
      (function(){
      var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
      s1.async=true;
      s1.src='https://embed.tawk.to/67f760160bd26b190e7e7a92/1iof4umle';
      s1.charset='UTF-8';
      s1.setAttribute('crossorigin','*');
      s0.parentNode.insertBefore(s1,s0);
      })();`}
    </Script>
  );
};

export const HotjarScript = () => {
  return (
    <Script id="hotjar" strategy="lazyOnload">
      {`(function(h,o,t,j,a,r){
               h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
               h._hjSettings={hjid:4968386,hjsv:6};
               a=o.getElementsByTagName('head')[0];
               r=o.createElement('script');r.async=1;
               r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
               a.appendChild(r);
           })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`}
    </Script>
  );
};

const GoogleAnalytics = ({ GTM_ID }: { GTM_ID: string }) => {
  return (
    <>
      <Script
        id="google-analytics-script"
        src={`https://www.googletagmanager.com/gtag/js?id=${GTM_ID}`}
        strategy="afterInteractive"
      />

      <Script id="google-analytics" strategy="afterInteractive">
        {`window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GTM_ID}');`}
      </Script>
    </>
  );
};

export function HeaderProviders() {
  return IS_PROD ? (
    <>
      <GoogleAnalytics GTM_ID={PROD_GTM_ID} />
      {/* <HotjarScript /> */}
      {/* <ChatScript /> */}
    </>
  ) : null;
}

export function Providers({ children }: { children: ReactNode }) {
  const { toast } = useToast();

  const memoUrql = useMemo(() => urqlClient(toast), [toast]);

  return (
    <AppConfigProvider>
      {/* <AppUserProvider> */}
      <SkeletonTheme>
        <DarkModeProvider darkMode="dark">
          <noscript>
            <iframe
              title="gtm"
              src={`https://www.googletagmanager.com/ns.html?id=${PROD_GTM_ID}`}
              height="0"
              width="0"
              style={{ display: 'none', visibility: 'hidden' }}
            />
          </noscript>
          <Provider value={memoUrql}>{children}</Provider>
          <Toaster />
        </DarkModeProvider>
      </SkeletonTheme>
      {/* </AppUserProvider> */}
    </AppConfigProvider>
  );
}
